import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStore = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "0 0 32 32",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.3333 12.16A2.1333 2.1333 0 0 0 9.6 12.16A2.1333 2.1333 0 0 0 13.8667 12.16A2.1333 2.1333 0 0 0 18.1333 12.16A2.1333 2.1333 0 0 0 22.4 12.16A2.1333 2.1333 0 0 0 26.6667 12.16L26.6667 7.4667A1.28 1.28 0 0 0 25.3867 6.1867L6.6133 6.1867A1.28 1.28 0 0 0 5.3333 7.4667ZM7.04 14.2933L7.04 24.1067A1.7067 1.7067 0 0 0 8.7467 25.8133L23.2533 25.8133A1.7067 1.7067 0 0 0 24.96 24.1067L24.96 14.2933M7.04 21.12L24.96 21.12",
				stroke: "white",
				strokeWidth: 5.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.3333 12.16A2.1333 2.1333 0 0 0 9.6 12.16A2.1333 2.1333 0 0 0 13.8667 12.16A2.1333 2.1333 0 0 0 18.1333 12.16A2.1333 2.1333 0 0 0 22.4 12.16A2.1333 2.1333 0 0 0 26.6667 12.16L26.6667 7.4667A1.28 1.28 0 0 0 25.3867 6.1867L6.6133 6.1867A1.28 1.28 0 0 0 5.3333 7.4667Z",
				style: { fill: "var(--sticker-pastel,#FFC98E)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.04 21.12L24.96 21.12L24.96 24.1067A1.7067 1.7067 0 0 1 23.2533 25.8133L8.7467 25.8133A1.7067 1.7067 0 0 1 7.04 24.1067Z",
				style: { fill: "var(--sticker-accent,#E89A44)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.3333 12.16A2.1333 2.1333 0 0 0 9.6 12.16A2.1333 2.1333 0 0 0 13.8667 12.16A2.1333 2.1333 0 0 0 18.1333 12.16A2.1333 2.1333 0 0 0 22.4 12.16A2.1333 2.1333 0 0 0 26.6667 12.16L26.6667 7.4667A1.28 1.28 0 0 0 25.3867 6.1867L6.6133 6.1867A1.28 1.28 0 0 0 5.3333 7.4667ZM7.04 14.2933L7.04 24.1067A1.7067 1.7067 0 0 0 8.7467 25.8133L23.2533 25.8133A1.7067 1.7067 0 0 0 24.96 24.1067L24.96 14.2933M7.04 21.12L24.96 21.12",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				style: { stroke: "var(--sticker-dark,#9A6528)" }
			})
		]
	});
};
export default SvgStore;
